<template>
  <div class="page-content">
    <div class="page-header">
      <div>
        <BreadcrumbComponent :items="items" />
        <h1 class="page-title">Paramètres des Relevés</h1>
        <p class="page-subtitle">Personnalisez le message qui apparaît sur les relevés de compte</p>
      </div>
    </div>

    <div v-if="!loading">
      <v-row>
        <v-col cols="12" md="7">
          <v-card flat class="settings-card">
            <v-card-text class="pa-6">
              <div class="form-group">
                <label class="form-label">Message du relevé de compte</label>
                <p class="text-caption text--secondary mb-3">
                  Ce message apparaîtra en bas de chaque relevé de compte client (PDF). Vous pouvez y indiquer vos méthodes de paiement acceptées, un message de remerciement, vos coordonnées bancaires, etc.
                </p>
                <v-textarea
                  v-model="statementMessage"
                  outlined
                  rows="5"
                  hide-details
                  placeholder="Exemple: Merci pour votre confiance. Paiements acceptés: Cash, Chèque, Virement. Pour toute question, appelez le 509-XXXX-XXXX."
                ></v-textarea>
              </div>

              <div class="form-group">
                <label class="form-label">Message du reçu de vente</label>
                <p class="text-caption text--secondary mb-3">
                  Ce message apparaît sur les reçus de vente (PDF) générés depuis la fiche de vente.
                </p>
                <v-textarea
                  v-model="receiptMessage"
                  outlined
                  rows="3"
                  hide-details
                  placeholder="Exemple: Merci pour votre achat! Revenez nous voir bientôt."
                ></v-textarea>
              </div>

              <v-btn color="primary" depressed @click="save" :loading="saving" :disabled="saving" class="mt-2">
                <v-icon left small>mdi-content-save</v-icon>
                Enregistrer
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="5">
          <v-card flat class="settings-card">
            <v-card-text class="pa-6">
              <h3 class="text-subtitle-2 font-weight-bold mb-3">Aperçu du relevé</h3>
              <div class="preview-box">
                <div class="preview-header">
                  <strong>{{ storeName }}</strong>
                  <span class="text-caption text--secondary d-block">{{ storePhone }}</span>
                </div>
                <div class="preview-title">RELEVÉ DE COMPTE</div>
                <div class="preview-body">
                  <div class="preview-line"></div>
                  <div class="preview-line short"></div>
                  <div class="preview-line"></div>
                  <div class="preview-line short"></div>
                </div>
                <div class="preview-message" v-if="statementMessage">
                  {{ statementMessage }}
                </div>
                <div class="preview-message text--disabled" v-else>
                  (Aucun message configuré)
                </div>
                <div class="preview-footer">
                  KES LAKAY — Page 1/1
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <div v-else class="page-loader">
      <v-progress-circular indeterminate color="primary" size="40" width="3"></v-progress-circular>
    </div>

    <FlashMessage :position="'right bottom'"></FlashMessage>
  </div>
</template>

<script>
import BreadcrumbComponent from '../components/BreadcrumbComponent.vue'

export default {
  name: 'StatementSettingsView',
  components: { BreadcrumbComponent },
  data: () => ({
    items: [{ text: 'Paramètres Relevés', disabled: true, href: '/statement-settings' }],
    loading: true,
    saving: false,
    storeId: null,
    storeName: '',
    storePhone: '',
    statementMessage: '',
    receiptMessage: '',
  }),
  methods: {
    async load() {
      this.loading = true
      try {
        var bizId = JSON.parse(localStorage.business).id
        var r = await this.$axios.get('/stores?orderasc=name&business_id=' + bizId)
        if (r.data && r.data.length > 0) {
          var store = r.data[0]
          this.storeId = store.id
          this.storeName = store.name || ''
          this.storePhone = store.phone || ''
          this.statementMessage = store.statement_message || ''
          this.receiptMessage = store.receipt_message || ''
        }
      } catch (e) {
        console.error('Load error:', e)
      }
      this.loading = false
    },

    async save() {
      if (!this.storeId) return
      this.saving = true
      try {
        var data = {
          statement_message: this.statementMessage,
          receipt_message: this.receiptMessage,
        }
        await this.$axios.put('/stores/' + this.storeId + '?data=' + encodeURIComponent(JSON.stringify(data)))
        // Update local business cache
        try {
          var biz = JSON.parse(localStorage.business)
          biz.statement_message = this.statementMessage
          biz.receipt_message = this.receiptMessage
          localStorage.setItem('business', JSON.stringify(biz))
        } catch (e) { /* ignore */ }
        this.flashMessage.success({ title: 'Succès', message: 'Messages enregistrés' })
      } catch (e) {
        this.flashMessage.error({ title: 'Erreur', message: "Erreur lors de l'enregistrement" })
      }
      this.saving = false
    },
  },
  mounted() { this.load() },
}
</script>

<style scoped>
.settings-card {
  border: 1px solid #e8ecf1 !important;
  border-radius: 10px !important;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04) !important;
}

.form-group { margin-bottom: 20px; }
.form-label { display: block; font-size: 0.8125rem; font-weight: 600; color: #1a2332; margin-bottom: 4px; }

/* Preview */
.preview-box {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 20px;
  background: #fff;
  font-size: 0.75rem;
}

.preview-header {
  text-align: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
}

.preview-title {
  text-align: center;
  font-weight: 700;
  font-size: 0.8125rem;
  color: #194173;
  margin-bottom: 12px;
}

.preview-body {
  margin-bottom: 16px;
}

.preview-line {
  height: 8px;
  background: #f1f5f9;
  border-radius: 4px;
  margin-bottom: 6px;
}

.preview-line.short {
  width: 60%;
}

.preview-message {
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 6px;
  padding: 12px;
  text-align: center;
  font-style: italic;
  color: #475569;
  margin-bottom: 12px;
  white-space: pre-line;
  font-size: 0.6875rem;
  line-height: 1.5;
}

.preview-footer {
  text-align: center;
  font-size: 0.625rem;
  color: #94a3b8;
  border-top: 1px solid #e2e8f0;
  padding-top: 8px;
}
</style>
